import React from 'react';
import { ActionText } from './styled';
import { AiSvg } from 'src/assets/dynamicSvg';
import { QAItem } from './styled';
import { useSuggestions } from 'src/hooks/useSuggestions';
import ReactDOMServer from 'react-dom/server';
import { without } from 'lodash';
import { Poppins, Tooltip } from 'src/common';

interface SuggestionsItemProps {
  suggesterKeys: string[];
  type: 'SCENARIO' | 'ASSESSMENT';
  readonly?: boolean;
}

export const SuggestionsItem: React.FC<SuggestionsItemProps> = ({ suggesterKeys, type = 'SCENARIO', readonly }) => {
  const { isActive, saveKeys, hiddenSuggestionKeys } = useSuggestions({ keys: suggesterKeys });

  return (
    <Tooltip
      place="top"
      dataHtml={
        readonly
          ? 'No current suggestions'
          : isActive
            ? ReactDOMServer.renderToStaticMarkup(
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <span style={{ textAlign: 'center' }}>Show suggested next steps</span>
                  <span style={{ textAlign: 'center' }}>for this {type.toLowerCase()}</span>
                </div>,
              )
            : ReactDOMServer.renderToStaticMarkup(
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <span style={{ textAlign: 'center' }}>Hide suggested next steps</span>
                  <span style={{ textAlign: 'center' }}>for this {type.toLowerCase()}</span>
                </div>,
              )
      }
      dataId={`aishg`}
    >
      <QAItem
        data-cy="qa-suggestions"
        onClick={() => {
          if (readonly) return;
          if (isActive) {
            saveKeys(without(hiddenSuggestionKeys, ...suggesterKeys));
          } else {
            saveKeys([...hiddenSuggestionKeys, ...suggesterKeys]);
          }
        }}
      >
        <AiSvg />
        {readonly ? (
          <Poppins px={14} weight={500} color="cflowerBlue">
            Show Suggestions
          </Poppins>
        ) : (
          <ActionText>{isActive ? 'Show' : 'Hide'} Suggestions</ActionText>
        )}
      </QAItem>
    </Tooltip>
  );
};
